// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SanMarino from '../_raw/flag/icon_flag_san_marino.png';

export default () => <img src={SanMarino} alt="SanMarino" />;
